import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const PATHS = [
  { to: "/about", key: "about", title: "Our story & philosophy",
    text: "Earth in Hospice, what an ecoversity is, and Zarya's founding story." },
  { to: "/offerings", key: "offerings", title: "What we offer",
    text: "Learning and Skills Exchanges, healing practices, retreats on the land and community projects." },
  { to: "/join", key: "join", title: "Join the village",
    text: "Become an anchor person, wisdom councillor, key partner or learner." },
];

export const PathCards = () => (
  <section className="border-t border-border py-24 lg:py-28" data-testid="path-cards-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-primary">Explore Nia</p>
      <h2 className="mt-6 max-w-3xl font-display text-4xl font-bold leading-tight tracking-tight text-foreground sm:text-5xl">
        Find your way <span className="text-primary">in.</span>
      </h2>
      <div className="mt-14 grid gap-px border border-border bg-border md:grid-cols-3">
        {PATHS.map((p, i) => (
          <motion.div key={p.key} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.1 }}>
            <Link to={p.to} data-testid={`path-card-${p.key}`}
              className="group flex h-full flex-col justify-between gap-10 bg-card p-10 transition-colors duration-300 hover:bg-muted">
              <div>
                <h3 className="font-display text-3xl font-bold text-foreground">{p.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-foreground/70">{p.text}</p>
              </div>
              <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary">
                Explore <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
